import { gql, TypedDocumentNode } from '@apollo/client';
import { UpdateOrderAction, OrderState } from '../useUpdateOrder';
import { ORDER_SUMMARY_FRAGMENT, OrderSummary } from '../useOrderSummary';
import { ORDER_ITEM_FRAGMENT, OrderItem } from '../useOrder';

export type UpdateOrderShippingAddressMutation = {
  updateOrderShippingAddress: {
    __typename: 'UpdateOrderShippingAddressPayload';
    data: OrderSummary[];
    included: OrderItem[];
  };
};

export type UpdateOrderShippingAddressMutationVariables = {
  orderId: string;
  input: {
    data: {
      action_type: UpdateOrderAction.ChangeAddress;
      attributes: {
        country_code: string;
        order_state: OrderState.Default;
        selected_address_id: string;
      };
      id: string;
      type: 'orders';
    };
  };
};

export const UPDATE_ORDER_SHIPPING_ADDRESS_MUTATION: TypedDocumentNode<
  UpdateOrderShippingAddressMutation,
  UpdateOrderShippingAddressMutationVariables
> = gql`
  mutation UpdateOrderShippingAddressMutation(
    $orderId: String!
    $input: UpdateOrderShippingAddressMutationVariables!
  ) {
    updateOrderShippingAddress(orderId: $orderId, input: $input)
      @rest(
        type: "UpdateOrderShippingAddressPayload"
        endpoint: "cart"
        path: "/v3.5/orders/{args.orderId}"
        method: "PATCH"
      ) {
      data @type(name: "RestOrderSummary") {
        ...OrderSummaryFragment
      }
      included @type(name: "RestOrderItem") {
        ...OrderItemFragment
      }
    }
  }
  ${ORDER_SUMMARY_FRAGMENT}
  ${ORDER_ITEM_FRAGMENT}
`;
